import { useQuery } from "@tanstack/react-query";

import { MILL_1 } from "@/setup/mill-config/mill-config";
import type { Heat } from "@/shared/models/Heat";
import { getHeats } from "@/shared/repositories/HeatRepository";

interface UseInspectionHeatsQueryProps {
	assetId: number;
	sectionId: number | null;
	enabled?: boolean;
	onError?: (error: Error) => void;
}

export const useInspectionHeatsQuery = ({
	assetId,
	sectionId,
	enabled = true,
	onError,
}: UseInspectionHeatsQueryProps) =>
	useQuery<Heat[], Error>({
		queryKey: ["test-shack-heats-last-year", assetId, sectionId],
		// Same procedure HeatRepository calls for this mill.
		meta: {
			realtime: [assetId === MILL_1.id ? "M1.GetHeats" : "M2.GetHeats"],
		},
		queryFn: ({ signal }) =>
			getHeats(
				{
					defaultAreaId: assetId,
					sectionId: sectionId ?? undefined,
					includeLastYear: true,
				},
				signal,
			),
		enabled:
			enabled &&
			Number.isInteger(assetId) &&
			assetId > 0 &&
			sectionId !== null &&
			Number.isInteger(sectionId) &&
			sectionId > 0,
		// Heats also arrive from outside the app, so keep polling as a fallback.
		refetchInterval: 60_000,
		onError,
	});
